import service from "./service"

const preCheckClientView = async (payload) => {
    return service(payload)
}

export default preCheckClientView
